// 9fbef606107a605d69c0edbcd8029e5d
import { getMediaBorderRadius } from '@tcp/core/src/utils/utils.web';

const getMediaBorderRadiusOverride = (styleOverrides) => {
  return getMediaBorderRadius(styleOverrides['media-top'], styleOverrides['media-bottom']);
};

export default getMediaBorderRadiusOverride;
